import { getURL } from '~publish/legacy/utils/formatters'

export const navigateToMigrationHub = (cta: string | undefined): void => {
  const migrationHubURL = cta
    ? `${getURL.getMigrationHubURL()}?${cta}`
    : `${getURL.getMigrationHubURL()}`

  window.location.assign(migrationHubURL)
}
